// requestTrackingCHexpress.js
import axios from 'axios';
import { baseURL } from './ApiURL';
/**
 * getChxpressGuias({ codVendedor = '', factura = '', cliente = '' })
 * Retorna la respuesta completa del endpoint externo (resp.data => { success, count, data })
 */
export const getChxpressGuias = async ({ codVendedor = '', factura = '', cliente = '' } = {}) => {
  try {
    // Usamos axios params para que haga el encode automáticamente
    const resp = await axios.get(`${baseURL}/chxpress/guias`, {
      params: {
        ...(codVendedor ? { CodVendedor: codVendedor } : {}),
        ...(factura ? { factura } : {}),
        ...(cliente ? { cliente } : {})
      }
    });

    return resp.data;
  } catch (err) {
    console.error('Error getChxpressGuias:', err);
    throw err; // lanzar para que el caller pueda manejar el error
  }
};

